import React, {Fragment, useState} from "react";
import {TextField} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {isValidPassword} from "_helpers";
import styles from "../../Users/Utilities/Styles.module.css";

export default function PasswordEntry({input, name, placeholder, performAction, meta: { touched, error } }) {

    const [values, setValues] = useState({
        password: '',
        showPassword: false,
    });
    const hasError = touched && !_.isEmpty(error) && !isValidPassword(values.password);

    const handleChange = (prop) => (event) => {
        const value = event.target.value;
        setValues({ ...values, [prop]: value });
        performAction(value);
    };

    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return(
        <Fragment>
            <TextField
                className={styles.textField}
                InputProps={{
                    classes: { root: styles.textField },
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                size="small"
                            >
                                {values.showPassword ?
                                    <VisibilityOff sx={{width: '20px', height: '20px'}} /> :
                                    <Visibility sx={{width: '20px', height: '20px'}} />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
                FormHelperTextProps={{ className: styles.helperText }}
                {...input}
                error={ hasError }
                value={values.password}
                id="password"
                name={name}
                variant="outlined"
                onChange={handleChange('password')}
                type={values.showPassword ? 'text' : 'password'}
                placeholder={placeholder}
                helperText={ hasError ? error : undefined }
            />
        </Fragment>
    )
}